

import { ColumnState } from 'ag-grid-community';

import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { BaseDocumentDownload } from '../../base/base-document-download';
import { User } from '../user.model';

export enum UsersActionTypes {
    LoadUsers = '[Users] Load',
    LoadUsersSuccess = '[Users] Load success',
    LoadUsersFail = '[Users] Load fail',
    UpdateUser = '[Users] Update',
    UpdateUserSuccess = '[Users] Update success',
    UpdateUserFail = '[Users] Update fail',
    CreateUser = '[Users] Create',
    CreateUserSuccess = '[Users] Create success',
    CreateUserFail = '[Users] Create fail',
    DeleteUser = '[Users] Delete',
    DeleteUserSuccess = '[Users] Delete success',
    DeleteUserFail = '[Users] Delete fail',
    LoadUsersByCompanyId = '[Users] Load by comapny id',
    ClearUsers = '[Users] Clear',
    SortUsers = '[Users] Sort',
    CancellationRequest = '[Users] Cancellation request',
    CancellationRequestSuccess = '[Users] Cancellation request success',
    CancellationRequestFail = '[Users] Cancellation request fail',
    DownloadDocuments = '[Users] DownloadDocuments',
    DownloadDocumentsSuccess = '[Users] DownloadDocuments success',
    DownloadDocumentstFail = '[Users] DownloadDocuments fail',
    DownloadedDocumentsSuccess = '[Users] DownloadedDocuments success',
}
@ShowLoader()
export class LoadUsers implements Action {
    readonly type = UsersActionTypes.LoadUsers;
}
@HideLoader(UsersActionTypes.LoadUsers)
export class LoadUsersSuccess implements Action {
    readonly type = UsersActionTypes.LoadUsersSuccess;
    constructor(public payload: User[]) { }
}
@HideLoader(UsersActionTypes.LoadUsers)
export class LoadUsersFail implements Action {
    readonly type = UsersActionTypes.LoadUsersFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class UpdateUser implements Action {
    readonly type = UsersActionTypes.UpdateUser;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.UpdateUser)
export class UpdateUserSuccess implements Action {
    readonly type = UsersActionTypes.UpdateUserSuccess;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.UpdateUser)
export class UpdateUserFail implements Action {
    readonly type = UsersActionTypes.UpdateUserFail;
    constructor(public payload: string) { }
}


@ShowLoader()
export class DeleteUser implements Action {
    readonly type = UsersActionTypes.DeleteUser;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.DeleteUser)
export class DeleteUserSuccess implements Action {
    readonly type = UsersActionTypes.DeleteUserSuccess;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.DeleteUser)
export class DeleteUserFail implements Action {
    readonly type = UsersActionTypes.DeleteUserFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class CreateUser implements Action {
    readonly type = UsersActionTypes.CreateUser;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.CreateUser)
export class CreateUserSuccess implements Action {
    readonly type = UsersActionTypes.CreateUserSuccess;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.CreateUser)
export class CreateUserFail implements Action {
    readonly type = UsersActionTypes.CreateUserFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class LoadUsersByCompanyId implements Action {
    readonly type = UsersActionTypes.LoadUsersByCompanyId;
    constructor(public companyId: number) { }
}

export class ClearUsers implements Action {
    readonly type = UsersActionTypes.ClearUsers;
}


export class SortUsers implements Action {
    readonly type = UsersActionTypes.SortUsers;
    constructor(public columnState: ColumnState[]) { }
}
@ShowLoader()
export class CancellationRequest implements Action {
    readonly type = UsersActionTypes.CancellationRequest;
    constructor(public id: string) { }
    }
@HideLoader(UsersActionTypes.CancellationRequest)
export class CancellationRequestSuccess implements Action {
    readonly type = UsersActionTypes.CancellationRequestSuccess;
    constructor(public user: User) { }
}
@HideLoader(UsersActionTypes.CancellationRequest)
export class CancellationRequestFail implements Action {
    readonly type = UsersActionTypes.CancellationRequestFail;
    constructor(public payload: string) { }
}
@ShowLoader()
export class DownloadDocuments implements Action {
    readonly type = UsersActionTypes.DownloadDocuments;
    constructor(public id: string) { }
    }
@HideLoader(UsersActionTypes.DownloadDocuments)
export class DownloadDocumentsSuccess implements Action {
    readonly type = UsersActionTypes.DownloadDocumentsSuccess;
    constructor(public payload: BaseDocumentDownload[]) { }
}
@HideLoader(UsersActionTypes.DownloadDocuments)
export class DownloadDocumentsFail implements Action {
    readonly type = UsersActionTypes.DownloadDocumentstFail;
    constructor(public payload: string) { }
}

export class DownloadedDocumentsSuccess implements Action {
    readonly type = UsersActionTypes.DownloadedDocumentsSuccess;
    constructor() { }
}

export type UsersActions =
    | LoadUsers | LoadUsersSuccess | LoadUsersFail
    | CreateUser | CreateUserSuccess | CreateUserFail
    | UpdateUser | UpdateUserSuccess | UpdateUserFail
    | DeleteUser | DeleteUserSuccess | DeleteUserFail
    | LoadUsersByCompanyId
    | ClearUsers | SortUsers
    | CancellationRequest | CancellationRequestSuccess | CancellationRequestFail
    | DownloadDocuments | DownloadDocumentsSuccess | DownloadDocumentsFail | DownloadedDocumentsSuccess
    ;
